class CertifiedSkilledWrapper extends HTMLElement {
  constructor() {
    super();
    const target = this.querySelector('.certified-skilled__wrapper-rotating-images');
    const items = this.querySelectorAll('.certified-skilled__wrapper-rotating-images-item');
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          target.classList.add('certified-skilled__rotate--active');
          items.forEach((ele) => {
            ele.classList.add('certified-skilled__rotate-item--active');
          });
        } else {
          target.classList.remove('certified-skilled__rotate--active');
          items.forEach((ele) => {
            ele.classList.remove('certified-skilled__rotate-item--active');
          });
        }
      });
    }, observerOptions);

    observer.observe(target);
  }
}

customElements.define('certified-skilled-wrapper', CertifiedSkilledWrapper);
